// source: witbooking/backoffice/amenities/v1/amenity_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.witbooking.backoffice.amenities.v1.Amenity', null, global);
goog.exportSymbol('proto.witbooking.backoffice.amenities.v1.AmenityCategory', null, global);
goog.exportSymbol('proto.witbooking.backoffice.amenities.v1.AmenityTranslation', null, global);
goog.exportSymbol('proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.amenities.v1.AmenityTranslation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.amenities.v1.AmenityTranslation.displayName = 'proto.witbooking.backoffice.amenities.v1.AmenityTranslation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.amenities.v1.Amenity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.amenities.v1.Amenity.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.amenities.v1.Amenity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.amenities.v1.Amenity.displayName = 'proto.witbooking.backoffice.amenities.v1.Amenity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.displayName = 'proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.displayName = 'proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.amenities.v1.AmenityTranslation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.amenities.v1.AmenityTranslation;
  return proto.witbooking.backoffice.amenities.v1.AmenityTranslation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.amenities.v1.AmenityTranslation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation} returns this
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation} returns this
 */
proto.witbooking.backoffice.amenities.v1.AmenityTranslation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.amenities.v1.Amenity.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.amenities.v1.Amenity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.amenities.v1.Amenity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.Amenity.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    icon: jspb.Message.getFieldWithDefault(msg, 2, ""),
    translationsList: jspb.Message.toObjectList(msg.getTranslationsList(),
    proto.witbooking.backoffice.amenities.v1.AmenityTranslation.toObject, includeInstance),
    category: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.amenities.v1.Amenity;
  return proto.witbooking.backoffice.amenities.v1.Amenity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.amenities.v1.Amenity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setIcon(value);
      break;
    case 3:
      var value = new proto.witbooking.backoffice.amenities.v1.AmenityTranslation;
      reader.readMessage(value,proto.witbooking.backoffice.amenities.v1.AmenityTranslation.deserializeBinaryFromReader);
      msg.addTranslations(value);
      break;
    case 4:
      var value = /** @type {!proto.witbooking.backoffice.amenities.v1.AmenityCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.amenities.v1.Amenity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.amenities.v1.Amenity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.Amenity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIcon();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTranslationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.witbooking.backoffice.amenities.v1.AmenityTranslation.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string ticker = 1;
 * @return {string}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.getTicker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity} returns this
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.setTicker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string icon = 2;
 * @return {string}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.getIcon = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity} returns this
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.setIcon = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated AmenityTranslation translations = 3;
 * @return {!Array<!proto.witbooking.backoffice.amenities.v1.AmenityTranslation>}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.getTranslationsList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.amenities.v1.AmenityTranslation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.amenities.v1.AmenityTranslation, 3));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.amenities.v1.AmenityTranslation>} value
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity} returns this
*/
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.setTranslationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityTranslation}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.addTranslations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.witbooking.backoffice.amenities.v1.AmenityTranslation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity} returns this
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.clearTranslationsList = function() {
  return this.setTranslationsList([]);
};


/**
 * optional AmenityCategory category = 4;
 * @return {!proto.witbooking.backoffice.amenities.v1.AmenityCategory}
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.getCategory = function() {
  return /** @type {!proto.witbooking.backoffice.amenities.v1.AmenityCategory} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.AmenityCategory} value
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity} returns this
 */
proto.witbooking.backoffice.amenities.v1.Amenity.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest;
  return proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    amenitiesList: jspb.Message.toObjectList(msg.getAmenitiesList(),
    proto.witbooking.backoffice.amenities.v1.Amenity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse;
  return proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.amenities.v1.Amenity;
      reader.readMessage(value,proto.witbooking.backoffice.amenities.v1.Amenity.deserializeBinaryFromReader);
      msg.addAmenities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmenitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.witbooking.backoffice.amenities.v1.Amenity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Amenity amenities = 1;
 * @return {!Array<!proto.witbooking.backoffice.amenities.v1.Amenity>}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.getAmenitiesList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.amenities.v1.Amenity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.amenities.v1.Amenity, 1));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.amenities.v1.Amenity>} value
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse} returns this
*/
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.setAmenitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.witbooking.backoffice.amenities.v1.Amenity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.amenities.v1.Amenity}
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.addAmenities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.witbooking.backoffice.amenities.v1.Amenity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse} returns this
 */
proto.witbooking.backoffice.amenities.v1.GetAmenitiesResponse.prototype.clearAmenitiesList = function() {
  return this.setAmenitiesList([]);
};


/**
 * @enum {number}
 */
proto.witbooking.backoffice.amenities.v1.AmenityCategory = {
  SERVICE: 0,
  FACILITY: 1
};

goog.object.extend(exports, proto.witbooking.backoffice.amenities.v1);
